import { viewSettingsActions } from '../../services';
import { ScreenType } from '../../model';

const parseView = ( name, layout ) => {
  if( !layout ) {
    return null;
  }

  if( !layout.title ) {
    console.warn( `Title is missing on the ${name} layout` );
    return null;
  }

  return { 
    key: layout.title,
    screen: ScreenType[layout.screenType].toLowerCase(),
    type: layout.view || 'list'
  };
};

export const viewSettingsReducer = ( state = {}, action ) => {
  switch ( action.type ) {
    case viewSettingsActions.LOAD:
      return Object.keys( action.data ).reduce( ( current, item ) => {
        const parsed = parseView( item, action.data[item] );
        if( !parsed ) {
          return current;
        }

        if ( !current[parsed.key] ) {
          current[parsed.key] = { [parsed.screen]: { [parsed.type]: action.data[item] } };
          return current;
        }

        if( !current[parsed.key][parsed.screen] ) {
          current[parsed.key][parsed.screen] = { [parsed.type]: action.data[item] };
          return current;
        }

        current[parsed.key][parsed.screen][parsed.type] = action.data[item];
        return current;
      }, {} );
    default:
      return state;
  }
};